<template>
  <div class="ship-manage">
    <ship-check v-if="showManage=='ship-check'"
                :clientWidth="clientWidth"
                :changeWidth="changeWidth"
                :checkInfo="checkInfo"
                @clearManageInterval="clearManageInterval"></ship-check>
    <crew-info v-if="showManage=='crew-info'"
               :clientWidth="clientWidth"
               :changeWidth="changeWidth"
               :crewInfo="crewInfo"
               @clearManageInterval="clearManageInterval"></crew-info>
    <manage-cost v-if="showManage=='manage-cost'"
                 :clientWidth="clientWidth"
                 :changeWidth="changeWidth"
                 :manageInfo="manageInfo"></manage-cost>
  </div>
</template>
<script>
import * as echarts from "echarts";
import shipCheck from "./shipCheck.vue";
import crewInfo from "./crewInfo.vue";
import manageCost from "./manageCost.vue";
export default {
  components: { shipCheck, crewInfo, manageCost },
  props: {
    clientWidth: {
      type: Number,
      default: () => {
        return null;
      },
    },
    crewInfo: {
      type: Object,
      default: () => {
        return null;
      },
    },
    checkInfo: {
      type: Object,
      default: () => {
        return null;
      },
    },
    manageInfo: {
      type: Object,
      default: () => {
        return null;
      },
    },
    showManage: {
      type: String,
      default: () => {
        return null;
      },
    },
    changeWidth: {
      type: Boolean,
      default: () => {
        return null;
      },
    },
  },
  watch: {},
  methods: {
    clearManageInterval() {
      this.$emit("clearManageInterval");
    },
  },
};
</script>
<style lang="scss" scoped>
.ship-manage {
  width: 100%;
  height: 100%;
}
</style>